"use client"

import { useEffect } from "react"

const DEPLOY_TAG = process.env.NEXT_PUBLIC_DEPLOY_TAG ?? "local"
const GIT_BRANCH = process.env.NEXT_PUBLIC_GIT_BRANCH ?? "local"
const APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION ?? "local"

export function AppVersionLogger() {
  useEffect(() => {
    // Intentional: surface deploy metadata in DevTools for ops/debugging.
    // eslint-disable-next-line no-console -- deploy/version banner
    console.log(
      `[Stream Hub] Deploy tag: ${DEPLOY_TAG} | Branch: ${GIT_BRANCH} | App version: ${APP_VERSION}`
    )
  }, [])

  return null
}
